import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { getAvatarPath } from '@/lib/avatar-utils';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  avatarId: number | null;
  displayName: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_CLASSES: Record<NonNullable<UserAvatarProps['size']>, string> = {
  sm: 'h-10 w-10',
  md: 'h-12 w-12',
  lg: 'h-24 w-24',
};

const TEXT_SIZE_CLASSES: Record<NonNullable<UserAvatarProps['size']>, string> = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-3xl',
};

export function UserAvatar({ avatarId, displayName, size = 'md', className }: UserAvatarProps) {
  const sizeClass = SIZE_CLASSES[size];
  const textSizeClass = TEXT_SIZE_CLASSES[size];
  const fallbackLetter = displayName ? displayName[0].toUpperCase() : '?';

  return (
    <Avatar className={cn(sizeClass, className)}>
      {avatarId !== null && (
        <AvatarImage
          src={getAvatarPath(avatarId)}
          alt={displayName || 'אווטאר'}
        />
      )}
      <AvatarFallback className={cn('bg-muted font-semibold', textSizeClass)}>
        {fallbackLetter}
      </AvatarFallback>
    </Avatar>
  );
}

export default UserAvatar;
